import { render, staticRenderFns } from "./WealthPortfolioWithdrawReview.vue?vue&type=template&id=b84423ee&scoped=true&"
import script from "./WealthPortfolioWithdrawReview.vue?vue&type=script&lang=ts&"
export * from "./WealthPortfolioWithdrawReview.vue?vue&type=script&lang=ts&"
import style0 from "./WealthPortfolioWithdrawReview.vue?vue&type=style&index=0&id=b84423ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84423ee",
  null
  
)

export default component.exports